import { Component, OnInit } from '@angular/core';
import { NgForm } from "@angular/forms";
import { Router, ActivatedRoute } from '@angular/router';
import { RolemanagementService } from "../../staff/Shared/rolemanagement.service";
import { CommonmastersService } from "../../commonmasters/commonmasters.service";

import { ToasterserviceService } from "../../utility/shared/toasterservice.service";
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { Toastpayload } from "../../utility/shared/toastpayload";
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-rolemanagement',
  templateUrl: './rolemanagement.component.html',
  styleUrls: ['./rolemanagement.component.css']
})

export class RolemanagementComponent implements OnInit {

  DesignationList: any[] = [];
  ModulesList: any[] = [];
  AddButtonText: string = "Add";
  ErrorText: string;
  toast: Toastpayload;

  constructor(private router: Router,
    public rolemanagementService: RolemanagementService,
    private commonmastersService: CommonmastersService,
    private toasterserviceService: ToasterserviceService,
    ) { }

  ngOnInit() {
    this.GetDesignationList();
    this.GetRolesList();
    this.resetForm();
  }

  resetForm(form?: NgForm) {
    if (form != null)
      form.reset();

    this.rolemanagementService.selectedRolemanagement = {
      Id: 0,
      DesignationId: 0,
      ModulesId: 0,
      ModulesName: null,
      IsView: null,
      IsCreate: null,
      IsEdit: null,
      IsDelete: null,
      IsPrint: null,
      EmployeeId: null,
      EmployeeBranchId: null,
      CompanyId: null,
      SaasId: null,
      CreatedDate: null,
      ModifiedDate: null,
      IsActive: null,
      Flag: 0,
      ListByDesignationId: false,
    }
  }

  onSubmit(form: NgForm) {

    this.toast = {
      message: "No Message Now!",
      title: 'Role management',
      ic: {
        timeOut: 2000,
        closeButton: true,
      } as IndividualConfig,
      type: 'success',
    };

    if (form.value.designationId != 0) {

      this.rolemanagementService.IUDRolemanagement(this.rolemanagementService.rolemanagementList, form)
        .subscribe(data => {
          // this.router.navigate(['/rolemanagementlist']);
          this.ErrorText = 'Successfully saved.';

          this.toast.title = 'Role management';
          this.toast.message = 'Role successfully saved.'
          this.toast.type = 'success';
          this.toasterserviceService.showToast(this.toast);
        })
    }
  }

  GetDesignationList() {

    this.commonmastersService.GetDesignationList().subscribe(data => {
      this.DesignationList = data;
    })
  }

  GetRolesList() {

    this.rolemanagementService.GetRolesList().subscribe(data => {
      this.rolemanagementService.rolemanagementList = data;
      //  console.log(data);     
    })
  }

  editModulesId: any = '';
  Edit(ModulesId: any): void {
    this.editModulesId = ModulesId;
  }

  selectChange(designationId: any): void {

    this.rolemanagementService.rolemanagementList = []; // clearing the previous list
    if (designationId != 0) {
      this.rolemanagementService.GetRolesListbyId(designationId)
        .toPromise()
        .then(data => {
          if (data.length > 0) {
            this.rolemanagementService.rolemanagementList = data;
          }
          else {
            this.rolemanagementService.rolemanagementList = [] // clearing the previous list
            this.GetRolesList();
            this.rolemanagementService.selectedRolemanagement.DesignationId = designationId;
          }
        });
    }
  }

}
